<template>
  <div v-loading="loading">
    <el-table :data="list" empty-text="There are no activities yet" style="width: 100%" border>
      <el-table-column prop="modified" label="Date" width="180" >
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.modified | formatDatetime  }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="operation" label="Operation">
        <template slot-scope="scope" >{{getDescription( scope.row)}}</template>
      </el-table-column>

      <el-table-column fixed="right" align="center" label="Operations" width="120">
        <template slot-scope="scope">
          <el-tooltip content="Details" placement="top">
            <el-button
              icon="el-icon-fa-search"
              size="small"
              type="text"
              @click="open(scope.row)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-button
      v-if="!last"
      @click="fetch()"
      type="infor"
      class="mt-3 w-100"
      icon="el-icon-fa-plus"
    >Load more...</el-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import stringUtils from "@/shared/utils/string-utils";

/* eslint-disable */
export default {
  name: "app-activity-list",

  props: {
    user: Object
  },

  computed: {
    ...mapGetters({
      loading: "activity/loading",
      list: "activity/list",
      last: "activity/last",
      hasRoleToFullHistory: "activity/hasRoleToFullHistory"
    })
  },

  created() {
    this.$store.dispatch("activity/setup", this.user);
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("activity/clear");
    next();
  },

  methods: {
    ...mapActions({
      fetch: "activity/fetch"
    }),

    getDescription (activity){
      console.log(activity);
      
      return stringUtils.capitalize(activity.operation) + " " + activity.entityPath + " "  + activity.data.name +  " by (" + activity.data.modifiedBy.email + ")"
    },

    open(activity) {
      this.$router.push({
        name: `${activity.entityName}HistorySingle`,
        params: { id: activity.data.id }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/activity/activity-list.vue?7a8138c2